//	Minimal scales: linear (values → pixels) and band (categories → slots).

export function linear(domain, range) {
	let [d0, d1] = domain;
	const [r0, r1] = range;
	if (d0 === d1) {
		d0 -= 1;
		d1 += 1;
	}
	// Normalize before multiplying: a subnormal data span would make a cached
	// pixels-per-unit multiplier overflow even though each plotted ratio is finite.
	const scale = (v) => r0 + ((v - d0) / (d1 - d0)) * (r1 - r0);
	scale.invert = (p) => d0 + ((p - r0) / (r1 - r0)) * (d1 - d0);
	scale.domain = [d0, d1];
	scale.range = [r0, r1];
	return scale;
}

//	n equal slots across [r0, r1]; paddingInner is the gap fraction between slots, paddingOuter the edge fraction
export function band(n, range, paddingInner = 0.2, paddingOuter = 0.1) {
	const [r0, r1] = range;
	const count = Math.max(1, n);
	const step = (r1 - r0) / Math.max(count - paddingInner + 2 * paddingOuter, 1e-9);
	const bandwidth = step * (1 - paddingInner);
	const start = r0 + step * paddingOuter;
	return {
		step,
		bandwidth,
		start: (i) => start + i * step,
		center: (i) => start + i * step + bandwidth / 2,
		//	nearest slot for a pixel position (hit testing)
		index: (p) => Math.max(0, Math.min(count - 1, Math.round((p - start - bandwidth / 2) / step))),
	};
}
